export const createTableNameService = ({ supabase }) => {
  const resolveTableName = async (preferredName) => {
    if (!supabase) return preferredName;
    try {
      const preferredResult = await supabase.from(preferredName).select("id").limit(1);
      if (preferredResult.error) return preferredName;

      return preferredName;
    } catch {
      return preferredName;
    }
  };

  const resolveInitialTableNames = async (fallbackTableNames) => {
    if (!supabase) return fallbackTableNames;

    return {
      vorlagen: await resolveTableName("vorlagen"),
      befundbeispiele: await resolveTableName("befundbeispiele"),
      protokolle: await resolveTableName("protokolle"),
      // Bibliothek is stored in the canonical Supabase table name.
      library: "library",
    };
  };

  return {
    resolveTableName,
    resolveInitialTableNames,
  };
};
